var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./assets/src/scss/core.scss";
import ReactDOM from "react-dom";
import { Header, getHeaderColumn, OffCanvasMenuContext, OffCanvasMenuIconHandler, mainFunctionAside } from "frontend-library";
// This to control the Aside menu on Product pages
mainFunctionAside();
var headerData = window.headerData && window.headerData.header_fields
    ? window.headerData.header_fields
    : null;
if (headerData) {
    var left = getHeaderColumn(__assign(__assign({ options: headerData.options }, headerData.left), { cssClasses: "Header__left-menu " }));
    var right = getHeaderColumn(__assign(__assign({ options: headerData.options }, headerData.right), { cssClasses: "Header__right-menu " }));
    ReactDOM.render((_jsx(OffCanvasMenuContext.Provider, __assign({ value: { openCloseHandler: OffCanvasMenuIconHandler } }, { children: _jsx(Header, { logo: headerData.logo, left: left, right: right }) }))), document.getElementById("header"));
}
